"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var Siema = (function () {
    function Siema(options) {
        var _this = this;
        this.perPage = 1;
        this.drag = { startX: 0, endX: 0, startY: 0, letItGo: false, preventClick: false };
        this.resizeHandler = function () {
            _this.resolveSlidesNumber();
            if (_this.currentSlide + _this.perPage > _this.innerElements.length) {
                _this.currentSlide =
                    _this.innerElements.length <= _this.perPage
                        ? 0
                        : _this.innerElements.length - _this.perPage;
            }
            _this.selectorWidth = _this.rootElement.offsetWidth;
            _this.buildSliderFrame();
        };
        this.touchstartHandler = function (e) {
            if (!e.target || !(e.target instanceof HTMLElement))
                return;
            var ignoreSiema = ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) !== -1;
            if (ignoreSiema) {
                return;
            }
            e.stopPropagation();
            _this.pointerDown = true;
            _this.drag.startX = e.touches[0].pageX;
            _this.drag.startY = e.touches[0].pageY;
        };
        this.touchendHandler = function (e) {
            e.stopPropagation();
            _this.pointerDown = false;
            _this.enableTransition();
            if (_this.drag.endX) {
                _this.updateAfterDrag();
            }
            _this.clearDrag();
        };
        this.touchmoveHandler = function (e) {
            e.stopPropagation();
            if (_this.drag.letItGo === null) {
                _this.drag.letItGo =
                    Math.abs(_this.drag.startY - e.touches[0].pageY) <
                        Math.abs(_this.drag.startX - e.touches[0].pageX);
            }
            if (_this.pointerDown && _this.drag.letItGo) {
                e.preventDefault();
                _this.drag.endX = e.touches[0].pageX;
                _this.sliderFrame.style.transition = "all 0ms ".concat(_this.config.easing);
                var currentSlide = _this.config.loop
                    ? _this.currentSlide + _this.perPage
                    : _this.currentSlide;
                var currentOffset = currentSlide * (_this.selectorWidth / _this.perPage);
                var dragOffset = _this.drag.endX - _this.drag.startX;
                var offset = _this.config.rtl
                    ? currentOffset + dragOffset
                    : currentOffset - dragOffset;
                _this.sliderFrame.style.transform = "translate3d(".concat((_this.config.rtl ? 1 : -1) * offset, "px, 0, 0)");
            }
        };
        this.mousedownHandler = function (e) {
            if (!e.target || !(e.target instanceof Element))
                return;
            var ignoreSiema = ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) !== -1;
            if (ignoreSiema) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            _this.pointerDown = true;
            _this.drag.startX = e.pageX;
        };
        this.mouseupHandler = function (e) {
            e.stopPropagation();
            _this.pointerDown = false;
            _this.rootElement.style.cursor = "-webkit-grab";
            _this.enableTransition();
            if (_this.drag.endX) {
                _this.updateAfterDrag();
            }
            _this.clearDrag();
        };
        this.mousemoveHandler = function (e) {
            if (!e.target || !(e.target instanceof Element))
                return;
            e.preventDefault();
            if (_this.pointerDown) {
                if (e.target.nodeName === "A") {
                    _this.drag.preventClick = true;
                }
                _this.drag.endX = e.pageX;
                _this.rootElement.style.cursor = "-webkit-grabbing";
                _this.sliderFrame.style.webkitTransition = "all 0ms ".concat(_this.config.easing);
                _this.sliderFrame.style.transition = "all 0ms ".concat(_this.config.easing);
                var currentSlide = _this.config.loop
                    ? _this.currentSlide + _this.perPage
                    : _this.currentSlide;
                var currentOffset = currentSlide * (_this.selectorWidth / _this.perPage);
                var dragOffset = _this.drag.endX - _this.drag.startX;
                var offset = _this.config.rtl
                    ? currentOffset + dragOffset
                    : currentOffset - dragOffset;
                _this.sliderFrame.style.transform = "translate3d(".concat((_this.config.rtl ? 1 : -1) * offset, "px, 0, 0)");
            }
        };
        this.mouseleaveHandler = function (e) {
            if (_this.pointerDown) {
                _this.pointerDown = false;
                _this.rootElement.style.cursor = "-webkit-grab";
                _this.drag.endX = e.pageX;
                _this.drag.preventClick = false;
                _this.enableTransition();
                _this.updateAfterDrag();
                _this.clearDrag();
            }
        };
        this.clickHandler = function (e) {
            if (_this.drag.preventClick) {
                e.preventDefault();
            }
            _this.drag.preventClick = false;
        };
        this.config = Siema.mergeSettings(options);
        var elem = typeof this.config.selector === "string"
            ? document.querySelector(this.config.selector)
            : this.config.selector;
        if (elem === null) {
            throw new Error("Something wrong with your selector 😭");
        }
        this.rootElement = elem;
        this.resolveSlidesNumber();
        this.sliderFrame = document.createElement("div");
        this.selectorWidth = this.rootElement.offsetWidth;
        this.innerElements = [].slice.call(this.rootElement.children);
        this.currentSlide = this.config.loop
            ? this.config.startIndex % this.innerElements.length
            : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage));
        this.init();
    }
    Siema.mergeSettings = function (options) {
        return __assign(__assign({}, Siema.settings), options);
    };
    Siema.prototype.attachEvents = function () {
        window.addEventListener("resize", this.resizeHandler);
        if (this.config.draggable) {
            this.pointerDown = false;
            this.drag = {
                startX: 0,
                endX: 0,
                startY: 0,
                letItGo: null,
                preventClick: false,
            };
            this.rootElement.addEventListener("touchstart", this.touchstartHandler);
            this.rootElement.addEventListener("touchend", this.touchendHandler);
            this.rootElement.addEventListener("touchmove", this.touchmoveHandler);
            this.rootElement.addEventListener("mousedown", this.mousedownHandler);
            this.rootElement.addEventListener("mouseup", this.mouseupHandler);
            this.rootElement.addEventListener("mouseleave", this.mouseleaveHandler);
            this.rootElement.addEventListener("mousemove", this.mousemoveHandler);
            this.rootElement.addEventListener("click", this.clickHandler);
        }
    };
    Siema.prototype.detachEvents = function () {
        window.removeEventListener("resize", this.resizeHandler);
        this.rootElement.removeEventListener("touchstart", this.touchstartHandler);
        this.rootElement.removeEventListener("touchend", this.touchendHandler);
        this.rootElement.removeEventListener("touchmove", this.touchmoveHandler);
        this.rootElement.removeEventListener("mousedown", this.mousedownHandler);
        this.rootElement.removeEventListener("mouseup", this.mouseupHandler);
        this.rootElement.removeEventListener("mouseleave", this.mouseleaveHandler);
        this.rootElement.removeEventListener("mousemove", this.mousemoveHandler);
        this.rootElement.removeEventListener("click", this.clickHandler);
    };
    Siema.prototype.init = function () {
        this.attachEvents();
        this.rootElement.style.overflow = "hidden";
        this.rootElement.style.direction = this.config.rtl ? "rtl" : "ltr";
        this.buildSliderFrame();
        this.config.onInit.call(this);
    };
    Siema.prototype.buildSliderFrame = function () {
        var widthItem = this.selectorWidth / this.perPage;
        var itemsToBuild = this.config.loop
            ? this.innerElements.length + 2 * this.perPage
            : this.innerElements.length;
        this.sliderFrame = document.createElement("div");
        this.sliderFrame.style.width = "".concat(widthItem * itemsToBuild, "px");
        this.sliderFrame.style.display = "flex";
        this.enableTransition();
        if (this.config.draggable) {
            this.rootElement.style.cursor = "-webkit-grab";
        }
        var docFragment = document.createDocumentFragment();
        if (this.config.loop) {
            for (var i = this.innerElements.length - this.perPage; i < this.innerElements.length; i++) {
                var element = this.buildSliderFrameItem(this.innerElements[i].cloneNode(true));
                docFragment.appendChild(element);
            }
        }
        for (var i = 0; i < this.innerElements.length; i++) {
            var element = this.buildSliderFrameItem(this.innerElements[i]);
            docFragment.appendChild(element);
        }
        if (this.config.loop) {
            for (var i = 0; i < this.perPage; i++) {
                var element = this.buildSliderFrameItem(this.innerElements[i].cloneNode(true));
                docFragment.appendChild(element);
            }
        }
        this.sliderFrame.appendChild(docFragment);
        this.rootElement.innerHTML = "";
        this.rootElement.appendChild(this.sliderFrame);
        this.slideToCurrent();
    };
    Siema.prototype.buildSliderFrameItem = function (elm) {
        var elementContainer = document.createElement("div");
        elementContainer.style.cssFloat = this.config.rtl ? "right" : "left";
        elementContainer.style.float = this.config.rtl ? "right" : "left";
        elementContainer.style.width = "".concat(this.config.loop
            ? 100 / (this.innerElements.length + this.perPage * 2)
            : 100 / this.innerElements.length, "%");
        elementContainer.appendChild(elm);
        return elementContainer;
    };
    Siema.prototype.resolveSlidesNumber = function () {
        var e_1, _a;
        if (typeof this.config.perPage === "number") {
            this.perPage = this.config.perPage;
        }
        else if (typeof this.config.perPage === "object") {
            this.perPage = 1;
            var sizes = Object.keys(this.config.perPage).map(Number);
            try {
                for (var sizes_1 = __values(sizes), sizes_1_1 = sizes_1.next(); !sizes_1_1.done; sizes_1_1 = sizes_1.next()) {
                    var viewport = sizes_1_1.value;
                    if (window.innerWidth >= viewport) {
                        this.perPage = this.config.perPage[viewport];
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (sizes_1_1 && !sizes_1_1.done && (_a = sizes_1.return)) _a.call(sizes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    Siema.prototype.prev = function (howManySlides, callback) {
        if (howManySlides === void 0) { howManySlides = 1; }
        if (this.innerElements.length <= this.perPage) {
            return;
        }
        var beforeChange = this.currentSlide;
        if (this.config.loop) {
            var isNewIndexClone = this.currentSlide - howManySlides < 0;
            if (isNewIndexClone) {
                this.disableTransition();
                var mirrorSlideIndex = this.currentSlide + this.innerElements.length;
                var mirrorSlideIndexOffset = this.perPage;
                var moveTo_1 = mirrorSlideIndex + mirrorSlideIndexOffset;
                var offset = (this.config.rtl ? 1 : -1) *
                    moveTo_1 *
                    (this.selectorWidth / this.perPage);
                var dragDistance = this.config.draggable
                    ? this.drag.endX - this.drag.startX
                    : 0;
                this.sliderFrame.style.transform = "translate3d(".concat(offset + dragDistance, "px, 0, 0)");
                this.currentSlide = mirrorSlideIndex - howManySlides;
            }
            else {
                this.currentSlide = this.currentSlide - howManySlides;
            }
        }
        else {
            this.currentSlide = Math.max(this.currentSlide - howManySlides, 0);
        }
        if (beforeChange !== this.currentSlide) {
            this.slideToCurrent(this.config.loop);
            this.config.onChange.call(this);
            if (callback) {
                callback.call(this);
            }
        }
    };
    Siema.prototype.next = function (howManySlides, callback) {
        if (howManySlides === void 0) { howManySlides = 1; }
        if (this.innerElements.length <= this.perPage) {
            return;
        }
        var beforeChange = this.currentSlide;
        if (this.config.loop) {
            var isNewIndexClone = this.currentSlide + howManySlides >
                this.innerElements.length - this.perPage;
            if (isNewIndexClone) {
                this.disableTransition();
                var mirrorSlideIndex = this.currentSlide - this.innerElements.length;
                var mirrorSlideIndexOffset = this.perPage;
                var moveTo_2 = mirrorSlideIndex + mirrorSlideIndexOffset;
                var offset = (this.config.rtl ? 1 : -1) *
                    moveTo_2 *
                    (this.selectorWidth / this.perPage);
                var dragDistance = this.config.draggable
                    ? this.drag.endX - this.drag.startX
                    : 0;
                this.sliderFrame.style.transform = "translate3d(".concat(offset + dragDistance, "px, 0, 0)");
                this.currentSlide = mirrorSlideIndex + howManySlides;
            }
            else {
                this.currentSlide = this.currentSlide + howManySlides;
            }
        }
        else {
            this.currentSlide = Math.min(this.currentSlide + howManySlides, this.innerElements.length - this.perPage);
        }
        if (beforeChange !== this.currentSlide) {
            this.slideToCurrent(this.config.loop);
            this.config.onChange.call(this);
            if (callback) {
                callback.call(this);
            }
        }
    };
    Siema.prototype.disableTransition = function () {
        this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
    };
    Siema.prototype.enableTransition = function () {
        this.sliderFrame.style.transition = "all ".concat(this.config.duration, "ms ").concat(this.config.easing);
    };
    Siema.prototype.goTo = function (index, callback) {
        if (this.innerElements.length <= this.perPage) {
            return;
        }
        var beforeChange = this.currentSlide;
        this.currentSlide = this.config.loop
            ? index % this.innerElements.length
            : Math.min(Math.max(index, 0), this.innerElements.length - this.perPage);
        if (beforeChange !== this.currentSlide) {
            this.slideToCurrent();
            this.config.onChange.call(this);
            if (callback) {
                callback.call(this);
            }
        }
    };
    Siema.prototype.slideToCurrent = function (enableTransition) {
        var _this = this;
        var currentSlide = this.config.loop
            ? this.currentSlide + this.perPage
            : this.currentSlide;
        var offset = (this.config.rtl ? 1 : -1) *
            currentSlide *
            (this.selectorWidth / this.perPage);
        if (enableTransition) {
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    _this.enableTransition();
                    _this.sliderFrame.style.transform = "translate3d(".concat(offset, "px, 0, 0)");
                });
            });
        }
        else {
            this.sliderFrame.style.transform = "translate3d(".concat(offset, "px, 0, 0)");
        }
    };
    Siema.prototype.updateAfterDrag = function () {
        var movement = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX);
        var movementDistance = Math.abs(movement);
        var howManySliderToSlide = this.config.multipleDrag
            ? Math.ceil(movementDistance / (this.selectorWidth / this.perPage))
            : 1;
        var slideToNegativeClone = movement > 0 && this.currentSlide - howManySliderToSlide < 0;
        var slideToPositiveClone = movement < 0 &&
            this.currentSlide + howManySliderToSlide >
                this.innerElements.length - this.perPage;
        if (movement > 0 &&
            movementDistance > this.config.threshold &&
            this.innerElements.length > this.perPage) {
            this.prev(howManySliderToSlide);
        }
        else if (movement < 0 &&
            movementDistance > this.config.threshold &&
            this.innerElements.length > this.perPage) {
            this.next(howManySliderToSlide);
        }
        this.slideToCurrent(slideToNegativeClone || slideToPositiveClone);
    };
    Siema.prototype.clearDrag = function () {
        this.drag = {
            startX: 0,
            endX: 0,
            startY: 0,
            letItGo: null,
            preventClick: this.drag.preventClick,
        };
    };
    Siema.prototype.remove = function (index, callback) {
        if (index < 0 || index >= this.innerElements.length) {
            throw new Error("Item to remove doesn't exist 😭");
        }
        var lowerIndex = index < this.currentSlide;
        var lastItem = this.currentSlide + this.perPage - 1 === index;
        if (lowerIndex || lastItem) {
            this.currentSlide--;
        }
        this.innerElements.splice(index, 1);
        this.buildSliderFrame();
        if (callback) {
            callback.call(this);
        }
    };
    Siema.prototype.insert = function (item, index, callback) {
        if (index < 0 || index > this.innerElements.length + 1) {
            throw new Error("Unable to inset it at this index 😭");
        }
        if (this.innerElements.indexOf(item) !== -1) {
            throw new Error("The same item in a carousel? Really? Nope 😭");
        }
        var shouldItShift = index <= this.currentSlide && this.currentSlide > 0 && this.innerElements.length;
        this.currentSlide = shouldItShift ? this.currentSlide + 1 : this.currentSlide;
        this.innerElements.splice(index, 0, item);
        this.buildSliderFrame();
        if (callback) {
            callback.call(this);
        }
    };
    Siema.prototype.prepend = function (item, callback) {
        this.insert(item, 0);
        if (callback) {
            callback.call(this);
        }
    };
    Siema.prototype.append = function (item, callback) {
        this.insert(item, this.innerElements.length + 1);
        if (callback) {
            callback.call(this);
        }
    };
    Siema.prototype.destroy = function (restoreMarkup, callback) {
        if (restoreMarkup === void 0) { restoreMarkup = false; }
        this.detachEvents();
        this.rootElement.style.cursor = "auto";
        if (restoreMarkup) {
            var slides = document.createDocumentFragment();
            for (var i = 0; i < this.innerElements.length; i++) {
                slides.appendChild(this.innerElements[i]);
            }
            this.rootElement.innerHTML = "";
            this.rootElement.appendChild(slides);
            this.rootElement.removeAttribute("style");
        }
        if (callback) {
            callback.call(this);
        }
    };
    Siema.settings = {
        selector: ".siema",
        duration: 200,
        easing: "ease-out",
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: false,
        rtl: false,
        onInit: function () { },
        onChange: function () { },
    };
    return Siema;
}());
exports.default = Siema;
